import { Avatar, Box, type IColumn, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type ReviewContactRow } from 'entities/Review'

export const clickedColumns: IColumn<ReviewContactRow>[] = [
  {
    field: 'full_name',
    name: 'Name',
    isDisabledChangeVisible: true,
    isSortable: true,
    minWidth: 266,
    renderRowCell: ({ fullName, avatarInfo }) => (
      <Box display={'flex'} alignItems={'center'} gap={'8px'}>
        <Avatar info={avatarInfo} size={24} />
        {fullName ? (
          <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactName'} ellipsis>
            {fullName}
          </Typography>
        ) : (
          <EmptyCell />
        )}
      </Box>
    ),
  },
  {
    field: 'number',
    name: 'Number',
    width: '30%',
    renderRowCell: ({ formattedNumber }) =>
      formattedNumber ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactNumber'}>
          {getLabelAsNumberInternationalFormat(formattedNumber)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'short_url_last_clicked_at',
    name: 'Clicked at',
    width: '65%',
    renderRowCell: ({ shortUrlLastClickedAt, lastClickedAt }) => {
      const clickedAt = shortUrlLastClickedAt ?? lastClickedAt

      if (!clickedAt) return <EmptyCell />

      return (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactClickedAt'}>
          {uiStore.dayjs(clickedAt).format(DayjsFormats.fullWithAtDash)}
        </Typography>
      )
    },
  },
]
